import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "@/components/Footer";
import { AuthAmbient } from "@/components/auth/AuthStage";
import "../styles/auth-animations.css";
export default function AuthLayout() {
  return (
     <div className="relative min-h-screen w-full flex flex-col justify-between overflow-hidden bg-gradient-to-b from-[#f4f6fa] via-[#e7ebf4] to-[#dfe4ef]">
      {/* Ambient animation layer: parallax dotted grid + drifting blobs */}
      <AuthAmbient />

      {/* MAIN CONTENT — scroll container; children use m-auto so a tall
          card scrolls naturally from the top instead of being clipped by
          justify-center (the old pattern cut off the card top on short
          screens with no way to scroll up). */}
      <div className="relative flex-1 flex overflow-y-auto px-4">
        <Outlet />
      </div>

      {/* FOOTER */}
      {/* <footer className="w-full py-2 bg-transparent">
        <div className="w-full flex flex-row max-sm:flex max-sm:flex-col-reverse max-sm:gap-2 items-center justify-between px-4 sm:px-10 text-[#000] text-xs sm:text-sm">

          <p className="text-center text-[#000] sm:text-left font-['inter'] font-normal text-sm mb-2 sm:mb-0">
            © 2025 Carolina Soccer Factory. All rights reserved.
          </p>

          <div className="flex gap-5">
           <a href="#" className="flex font-['inter'] font-normal text-sm text-black items-center gap-1 hover:underline"> <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"> <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect> <path d="M7 11V7a5 5 0 0 1 10 0v4"></path> </svg> Privacy </a>
           <a href="#" className="flex font-['inter'] font-normal text-sm text-black items-center gap-1 hover:underline"> <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"> <circle cx="12" cy="12" r="9"></circle> <path d="M9.1 9a3 3 0 1 1 4.8 2.2c-.7.5-1.2 1.1-1.2 1.8v1"></path> <line x1="12" y1="17" x2="12" y2="17"></line> </svg> Get help </a>
          </div>

        </div>
      </footer> */}
      <Footer isFixed={false} />
    </div>
  );
}
